import React from 'react';
const loaderImg = require('../../images/loader-image.gif');
// styles
const styles = require('./loading-screen.scss');

class LoadingScreenComponent extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
  }

  render() {
    return(
      <>
      <div className={styles.loaderWrapper}>
        <img src={loaderImg} width='200' alt='Portr Logo' />
        {/* TrustBox widget - Mini  */}
        <div className='trustpilot-widget' id='trustbox' data-locale='en-GB' data-template-id='53aa8807dec7e10d38f59f32'
          data-businessunit-id='5e559cdc1d562000013d923b' data-style-height='150px' data-style-width='100%' data-theme='light'>
            <a href='https://uk.trustpilot.com/review/airportr.com' target='_blank' rel='noopener'>Trustpilot</a>
        </div>
        {/* End TrustBox widget  */}
      </div>
      </>
    );
  }

}

export default LoadingScreenComponent;



// WEBPACK FOOTER //
// ./src/components/loading-screen/loading-screen.component.tsx